import dashboardCampaignsFilterSearchFormSubmit from '@hh.ru/analytics-js-events/build/clickme/employer/common/dashboard_campaigns_filter_search_form_submit';

import { fetchCampaignsCount } from 'components/CampaignCard/CampaignInfo/Actions/fetchCampaignsCount';
import { fetchCampaignsNextPage } from 'components/Dashboard/CampaignList/fetchCampaignsNextPage';

import { setPage } from 'store/autoReducers';
import {
    CampaignLoadState,
    setIsCampaignSearchLoading,
    setIsCampaignSearchUploaded,
    setLoadCampaigns,
} from 'store/models/dashboard';
import { AppThunkAction } from 'store/utils';

export const fetchCampaignsSearch =
    (campaignSearchValue: string, abortSignal: AbortSignal): AppThunkAction =>
    async (dispatch, getState) => {
        const currentStatus = getState().campaignTabsStatus;

        dashboardCampaignsFilterSearchFormSubmit({ searchValue: campaignSearchValue });

        dispatch([setLoadCampaigns(CampaignLoadState.Success), setPage(0)]);

        await dispatch(fetchCampaignsNextPage({ currentStatus, isCampaignSearch: true, abortSignal }));
        await dispatch(fetchCampaignsCount(abortSignal));

        if (!abortSignal?.aborted) {
            dispatch([setIsCampaignSearchLoading(false), setIsCampaignSearchUploaded(true)]);
        }
    };
